//
// Generated class AdyenProxyPaymentEntity
//

/// <reference path="AdyenProxyPaymentEntity_ManagedObject.ts" />

class AdyenProxyPaymentEntity extends AdyenProxyPaymentEntity_ManagedObject
{

}
